import { createSelector } from 'reselect';

import { ISelectInputOption } from '@r1-frontend/shared/types/ISelectInputOption';

import { IContactAddressState, IVerifiedAddressData } from '../initialState';

export interface IAddressProps {
    city: string,
    street: ISelectInputOption,
    house: ISelectInputOption,
    flat: string,
    companyId: number,
}

const getVerifiedAddressData = (state: IContactAddressState) => state.contactAddress.verifiedAddressData;

const selectAddressParams = (verifiedAddressData: IVerifiedAddressData): IAddressProps | null => {
    const {
        address,
        companyId,
    } = verifiedAddressData;

    if (!address) {
        return null;
    }

    const { city, street, house, flat } = address;

    if (!city || !street || !house) {
        return null;
    }

    return {
        city: city.label,
        street,
        house,
        flat: flat || '',
        companyId,
    };
};

export const selectAddressParamsMemoize = createSelector(
    [getVerifiedAddressData],
    selectAddressParams,
);
